export const MOCK_FILES = [
  {
    _created_at: '2025-04-07T07:16:36.872Z',
    _id: '1e1f456a-926f-43fb-a581-873aa693bbdd',
    _org: 'test-org',
    _schema: 'file',
    _title: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
    _updated_at: '2025-04-07T07:16:38.668Z',
    access_control: 'public-read',
    category: 'legal',
    document_type: 'document',
    filename: '07.04.2025_Bestellbestätigung_Max Spark.pdf',
    is_new: true,
    mime_type: 'application/pdf',
    public_url:
      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
    readable_size: '152.51 KB',
    s3ref: {
      bucket: 'epilot-prod-user-content',
      key: '16246022/bce1aa3f-c065-4985-8b77-e2baa70aeb3b/07.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
    },
    shared_with_end_customer: true,
    size_bytes: 156167,
    type: 'document'
  },
  {
    _created_at: '2025-04-04T13:52:22.441Z',
    _id: 'a3214d39-9ee7-4bb9-bd56-9ae35bef0333',
    _org: 'test-org',
    _schema: 'file',
    _title: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
    _updated_at: '2025-04-04T13:52:24.321Z',
    access_control: 'public-read',
    category: 'billing',
    document_type: 'document',
    filename: '04.04.2025_Bestellbestätigung_Max Spark.pdf',
    is_new: false,
    mime_type: 'application/pdf',
    public_url:
      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%25C3%25A4tigung_Max%2520Spark.pdf',
    readable_size: '152.64 KB',
    s3ref: {
      bucket: 'epilot-prod-user-content',
      key: '16246022/1e0e06a9-5fc7-499a-bd36-84cbf466d076/04.04.2025_Bestellbest%C3%A4tigung_Max%20Spark.pdf'
    },
    shared_with_end_customer: true,
    size_bytes: 156303,
    type: 'document'
  },
  {
    _created_at: '2025-06-10T09:21:22.434Z',
    _id: 'a18a9f26-d973-48b6-9b1c-27341f0f17ff',
    _org: 'test-org',
    _schema: 'file',
    _title: 'Ablesung 2025-06-10T11:21:21+02:00.jpg',
    _updated_at: '2025-06-10T09:21:22.434Z',
    access_control: 'private',
    category: 'documentation',
    document_type: 'image',
    filename: 'Ablesung 2025-06-10T11:21:21+02:00.jpg',
    height: 267,
    is_new: true,
    mime_type: 'image/png',
    public_url:
      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/835f4a8f-543e-4246-9011-dcebc41c987c/Ablesung%25202025-06-10T11%253A21%253A21%252B02%253A00.jpg',
    readable_size: '4.2 KB',
    s3ref: {
      bucket: 'epilot-prod-user-content',
      key: '16246022/835f4a8f-543e-4246-9011-dcebc41c987c/Ablesung%202025-06-10T11%3A21%3A21%2B02%3A00.jpg'
    },
    shared_with_end_customer: true,
    size_bytes: 4303,
    type: 'image',
    width: 119
  },
  {
    _created_at: '2025-03-15T12:45:18.567Z',
    _id: 'b7c8d9e0-f1a2-3456-789b-cdef01234567',
    _org: 'test-org',
    _schema: 'file',
    _title: 'Technical_Specifications.pdf',
    _updated_at: '2025-03-15T12:45:20.123Z',
    access_control: 'public-read',
    category: 'documentation',
    document_type: 'document',
    filename: 'Technical_Specifications.pdf',
    is_new: false,
    mime_type: 'application/pdf',
    public_url:
      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/technical-specs.pdf',
    readable_size: '3.1 MB',
    s3ref: {
      bucket: 'epilot-prod-user-content',
      key: '16246022/technical-specs.pdf'
    },
    shared_with_end_customer: false,
    size_bytes: 3250176,
    type: 'document'
  },
  {
    _created_at: '2025-02-28T08:30:45.234Z',
    _id: 'c9d0e1f2-3456-789a-bcde-f012345678ab',
    _org: 'test-org',
    _schema: 'file',
    _title: 'Service_Report.xlsx',
    _updated_at: '2025-02-28T08:30:47.891Z',
    access_control: 'private',
    category: 'documentation',
    document_type: 'spreadsheet',
    filename: 'Service_Report.xlsx',
    is_new: true,
    mime_type:
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    public_url:
      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/service-report.xlsx',
    readable_size: '892 KB',
    s3ref: {
      bucket: 'epilot-prod-user-content',
      key: '16246022/service-report.xlsx'
    },
    shared_with_end_customer: true,
    size_bytes: 913408,
    type: 'spreadsheet'
  },
  {
    _created_at: '2025-01-20T15:12:33.789Z',
    _id: 'd1e2f3a4-5678-90bc-def0-123456789cde',
    _org: 'test-org',
    _schema: 'file',
    _title: 'Warranty_Information.pdf',
    _updated_at: '2025-01-20T15:12:35.456Z',
    access_control: 'public-read',
    category: 'legal',
    document_type: 'document',
    filename: 'Warranty_Information.pdf',
    is_new: false,
    mime_type: 'application/pdf',
    public_url:
      'https://epilot-prod-user-content.s3.eu-central-1.amazonaws.com/16246022/warranty-info.pdf',
    readable_size: '1.2 MB',
    s3ref: {
      bucket: 'epilot-prod-user-content',
      key: '16246022/warranty-info.pdf'
    },
    shared_with_end_customer: true,
    size_bytes: 1258291,
    type: 'document'
  }
]
